<template>
  <div class="bottom-safe">
    <van-nav-bar
      title="已购私房课"
      left-text=""
      right-text=""
    />
    <episode-list
      ref="episodeList"
      :slug="slug"
      :editorChoiceOnly="false"
      :premiumOnly="false"
      :purchaseList="true"
      :limit="0"
    />
  </div>
</template>

<script>
  import EpisodeList from '../episode-list.vue'
  import Vue from 'vue'
  import { NavBar } from 'vant'
  Vue.use(NavBar)
  export default {
    // inject: ['reload'],
    name: "Purchased",
    components: {
      EpisodeList
    },
    data () {
      return {
        slug: this.$route.params.slug
      }
    },
    methods: {
    },
    mounted () {
    }
  }
</script>

<style lang="css" scoped>
  
</style>
